module.exports = __webpack_public_path__ + "img/socialmediadevelopers.71ae7891.png";